import z from 'zod';

import { AccessoryDetailCategoryTreeDtoSchema } from './AccessoryDetailCategoryTreeDto';
import { AccessoryDetailCategoryTreeDto } from './AccessoryDetailCategoryTreeDto';
import { CarbonDioxideDisplayLabelDtoSchema } from './CarbonDioxideDisplayLabelDto';
import { CarbonDioxideDisplayLabelDto } from './CarbonDioxideDisplayLabelDto';
import { CarbonDioxideDtoSchema } from './CarbonDioxideDto';
import { CarbonDioxideDto } from './CarbonDioxideDto';
import { CharacteristicSchema } from './Characteristic';
import { Characteristic } from './Characteristic';
import { SimpleMediaDtoSchema } from './SimpleMediaDto';
import { SimpleMediaDto } from './SimpleMediaDto';
import { SynonymDtoSchema } from './SynonymDto';
import { SynonymDto } from './SynonymDto';
import { TagMappingDtoSchema } from './TagMappingDto';
import { TagMappingDto } from './TagMappingDto';
import { UnitWeightDtoSchema } from './UnitWeightDto';
import { UnitWeightDto } from './UnitWeightDto';

export type AccessoryDto = {
	id: string;
	price: number | null;
	currencyCode: string | null;
	isPriceRecipeRelevant: boolean;
	characteristic: Characteristic | null;
	density: number | null;
	source: string | null;
	image: SimpleMediaDto | null;
	carbonDioxideValue: number | null;
	carbonDioxideLabel: CarbonDioxideDisplayLabelDto | null;
	nameSingularTranslations: { [key: string]: string };
	namePluralTranslations: { [key: string]: string };
	synonyms: { [key: string]: SynonymDto[] };
	unitWeights: UnitWeightDto[];
	tags: TagMappingDto[];
	categories: AccessoryDetailCategoryTreeDto[];
	carbonDioxide: CarbonDioxideDto[];
};

export const AccessoryDtoSchema: z.ZodType<AccessoryDto> = z.object({
	id: z.string(),
	price: z.number().nullable(),
	currencyCode: z.string().nullable(),
	isPriceRecipeRelevant: z.boolean(),
	characteristic: z.lazy(() => CharacteristicSchema).nullable(),
	density: z.number().nullable(),
	source: z.string().nullable(),
	image: z.lazy(() => SimpleMediaDtoSchema).nullable(),
	carbonDioxideValue: z.number().nullable(),
	carbonDioxideLabel: z.lazy(() => CarbonDioxideDisplayLabelDtoSchema).nullable(),
	nameSingularTranslations: z.record(z.string()),
	namePluralTranslations: z.record(z.string()),
	synonyms: z.record(z.array(z.lazy(() => SynonymDtoSchema))),
	unitWeights: z.lazy(() => UnitWeightDtoSchema).array(),
	tags: z.lazy(() => TagMappingDtoSchema).array(),
	categories: z.lazy(() => AccessoryDetailCategoryTreeDtoSchema).array(),
	carbonDioxide: z.lazy(() => CarbonDioxideDtoSchema).array(),
});
